import React from 'react';
import PropTypes from 'prop-types';
import { Container, Typography } from '@sm/wds-react';
import { IconXCircle } from '@sm/wds-icons';

import './nonbranded-endpage-header.scss';

const NonBrandedEndpageHeader = ({ copy }) => (
  <Container p={6} className="sm-nonbranded-endpage-header">
    <Typography align="center" component="section" variant="sectionTitle" color="light">
      <IconXCircle className="sm-nonbranded-endpage-header__icon wds-m-t-2 wds-m-r-2" />
      <Typography
        className="sm-nonbranded-endpage-header__copy wds-display--inline"
        align="center"
        component="section"
        variant="sectionTitle"
      >
        <strong>{copy}</strong>
      </Typography>
    </Typography>
  </Container>
);

NonBrandedEndpageHeader.propTypes = {
  copy: PropTypes.string.isRequired,
};

export default NonBrandedEndpageHeader;
